import { Injectable } from '@angular/core';
import { MessageType, showSnackBarMessage } from '@epicuro-next/state/snackbar';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import * as actions from '../actions';
import { renameArticleSuccess } from '../actions';

export const SUCCESS_MESSAGE = $localize`:@@NewsFeedRenameSuccess:Item renamed.`;

@Injectable()
export class RenameEffects {
  constructor(private actions$: Actions) {}

  // TODO: CHECK IF IT IS NEEDED
  public renameArticle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.renameArticle),
      map(({ id, title }) => ({ id, title })),
      switchMap(({ id, title }) => {
        // Engagement uses UUID in ID type
        // Epicuro uses Number in ID type
        if (typeof id === 'string') {
          // Engagement removed the Rename Endpoint
          // Once the Lookbook is updated so as its corresponding feed
          return of(renameArticleSuccess({ id, title }));
        }

        return EMPTY;
      }),
    ),
  );

  public showSuccessMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.renameArticleSuccess),
      map(() =>
        showSnackBarMessage({
          message: SUCCESS_MESSAGE,
          messageType: MessageType.SUCCESS,
        }),
      ),
    ),
  );
}
